import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

export default function SwitchMf() {
  /* ------------------ STATIC DATA ------------------ */
  const holdings = [
    {
      id: 1,
      fund: "Axis Bluechip Fund",
      units: 120.45,
      nav: 52.3,
    },
    {
      id: 2,
      fund: "HDFC Midcap Opportunities",
      units: 80.2,
      nav: 68.9,
    },
  ];

  const targetSchemes = [
    "ICICI Prudential Bluechip Fund",
    "SBI Flexicap Fund",
    "Kotak Emerging Equity Fund",
  ];

  const [fromHolding, setFromHolding] = useState(holdings[0]);
  const [toScheme, setToScheme] = useState(targetSchemes[0]);
  const [switchType, setSwitchType] = useState("Amount");
  const [value, setValue] = useState("");

  const estimatedAmount =
    switchType === "Units"
      ? (value * fromHolding.nav || 0).toFixed(2)
      : value || 0;

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
<style>{`
// .btn-outline-custom {
//     border: 1px solid rgba(15, 118, 110, 0.12);
//     color: #0f766e;
//     background: transparent;
// }
`}</style>

          {/* Header */}
          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Switch Mutual Fund</h3>

            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active">Switch</li>
              </ol>
            </nav>
          </div>

          {/* Switch Form */}
          <div className="card shadow-sm p-4 mb-4">
            <h5 className="mb-3">Switch Details</h5>

            {/* From Holding */}
            <div className="mb-3">
              <label className="form-label">From Holding</label>
              <select
                className="form-select"
                onChange={(e) =>
                  setFromHolding(
                    holdings.find((h) => h.id === Number(e.target.value)),
                  )
                }
              >
                {holdings.map((h) => (
                  <option key={h.id} value={h.id}>
                    {h.fund} — {h.units} units
                  </option>
                ))}
              </select>

              <small className="text-muted">
                NAV: ₹{fromHolding.nav} | Available Units: {fromHolding.units}
              </small>
            </div>

            {/* To Scheme */}
            <div className="mb-3">
              <label className="form-label">To Scheme</label>
              <select
                className="form-select"
                onChange={(e) => setToScheme(e.target.value)}
              >
                {targetSchemes.map((scheme, index) => (
                  <option key={index}>{scheme}</option>
                ))}
              </select>
            </div>

            {/* Switch Type */}
            <div className="mb-3">
              <label className="form-label">Switch By</label>
              <div className="d-flex gap-3">
                {["Amount", "Units"].map((type) => (
                  <div className="form-check" key={type}>
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={switchType === type}
                      onChange={() => setSwitchType(type)}
                    />
                    <label className="form-check-label">{type}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* Amount / Units */}
            <div className="mb-3">
              <label className="form-label">Enter {switchType}</label>
              <input
                type="number"
                className="form-control"
                placeholder={`Enter ${switchType}`}
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>

            {/* Info Messages */}
            <div className="alert alert-warning">
              Cutoff time: <strong>3:00 PM</strong>. Orders placed after cutoff
              will be processed on the next business day.
            </div>
          </div>

          {/* Summary */}
          <div className="card shadow-sm p-4 mb-4">
            <h5 className="mb-3">Summary</h5>

            <div className="row">
              <div className="col-md-6 mb-2">
                <strong>From:</strong> {fromHolding.fund}
              </div>
              <div className="col-md-6 mb-2">
                <strong>To:</strong> {toScheme}
              </div>
              <div className="col-md-6 mb-2">
                <strong>Switch Type:</strong> {switchType}
              </div>
              <div className="col-md-6 mb-2">
                <strong>Estimated Amount:</strong> ₹{estimatedAmount}
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="d-flex gap-3">
            <button className="btn btn-primary">Submit Switch</button>
            <button className="btn  btn-outline-custom">Track Status</button>
          </div>

          {/* Status Timeline */}
          <div className="card shadow-sm p-4 mt-4">
            <h6 className="mb-3">Switch Status Timeline</h6>

            <ul className="list-group">
              <li className="list-group-item">Order Submitted</li>
              <li className="list-group-item">Units Redeemed</li>
              <li className="list-group-item">Units Allotted (T+1)</li>
            </ul>
          </div>
        </div>
    </>
  );
}
